import { render, staticRenderFns } from "./AdminAccountError.vue?vue&type=template&id=44e6cb12&"
import script from "./AdminAccountError.vue?vue&type=script&lang=ts&"
export * from "./AdminAccountError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports